// Shared framer-motion variants for the Hall. Children animate between the
// "hidden" and "show" labels set on their nearest animated parent.

export const EASE_OUT = [0.22, 1, 0.36, 1];

export const staggerContainer = (staggerChildren = 0.08, delayChildren = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren, delayChildren } },
});

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE_OUT } },
};

// Not for elements that contain backdrop-blur: a filtered ancestor breaks it.
export const blurUp = {
  hidden: { opacity: 0, y: 16, filter: 'blur(10px)' },
  show: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { duration: 0.8, ease: EASE_OUT } },
};
